import { Box, Button, Flex, Text } from "@chakra-ui/react"
import { Link } from "@tanstack/react-router"
import { FaUserAstronaut } from "react-icons/fa"
import { FiLogOut, FiUser } from "react-icons/fi"

import useAuth from "@/hooks/useAuth"
import { isEmbeddedSession } from "@/utils"
import {
  MenuContent,
  MenuItem,
  MenuRoot,
  MenuSeparator,
  MenuTrigger,
} from "../ui/menu"

const UserMenu = () => {
  const { user, logout } = useAuth()
  const isEmbed = isEmbeddedSession()

  const handleLogout = async () => {
    logout()
  }

  return (
    <>
      {/* Desktop */}
      <Flex>
        <MenuRoot>
          <MenuTrigger asChild p={2}>
            <Button data-testid="user-menu" variant="solid" truncate>
              <FaUserAstronaut fontSize="18" />
              <Text>{user?.full_name || "User"}</Text>
            </Button>
          </MenuTrigger>

          <MenuContent>
            <MenuSeparator />

            <Link to="settings">
              <MenuItem
                closeOnSelect
                value="user-settings"
                gap={2}
                py={2}
                style={{ cursor: "pointer" }}
              >
                <FiUser fontSize="18px" />
                <Box flex="1">My Profile</Box>
              </MenuItem>
            </Link>

            {!isEmbed && (
              <MenuItem
                value="logout"
                gap={2}
                py={2}
                onClick={handleLogout}
                style={{ cursor: "pointer" }}
              >
                <FiLogOut />
                Log Out
              </MenuItem>
            )}
          </MenuContent>
        </MenuRoot>
      </Flex>
    </>
  )
}

export default UserMenu
